import { Routes, Route, Navigate } from 'react-router-dom';
import RequireAuth from './auth/RequireAuth.jsx';
import AppShell from './components/AppShell.jsx';
import Login from './pages/Login.jsx';
import ChangePassword from './pages/ChangePassword.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import Privacy from './pages/Privacy.jsx';
import SmsTerms from './pages/SmsTerms.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Customers from './pages/Customers.jsx';
import TripPlanner from './pages/TripPlanner.jsx';
import VisitSchedule from './pages/VisitSchedule.jsx';
import CustomerDetail from './pages/CustomerDetail.jsx';
import Notes from './pages/Notes.jsx';
import NoteCapture from './pages/NoteCapture.jsx';
import NoteDetail from './pages/NoteDetail.jsx';
import Followups from './pages/Followups.jsx';
import FollowupDetail from './pages/FollowupDetail.jsx';
import Blitz from './pages/Blitz.jsx';
import Pipeline from './pages/Pipeline.jsx';
import DealDetail from './pages/DealDetail.jsx';
import ChangeRequests from './pages/ChangeRequests.jsx';
import AIQuestions from './pages/AIQuestions.jsx';
import WeeklyRecap from './pages/WeeklyRecap.jsx';
import Settings from './pages/Settings.jsx';
import Help from './pages/Help.jsx';
import AdminUsers from './pages/admin/Users.jsx';
import AuditLog from './pages/admin/AuditLog.jsx';
import ManagerDashboard from './pages/admin/ManagerDashboard.jsx';
import BdmPerformance from './pages/admin/BdmPerformance.jsx';
import StaleFollowups from './pages/admin/StaleFollowups.jsx';
import Executive from './pages/admin/Executive.jsx';
import RepDetail from './pages/admin/RepDetail.jsx';
import AgingServiceOrders from './pages/AgingServiceOrders.jsx';
import Parts from './pages/Parts.jsx';
import Service from './pages/Service.jsx';
import TrailerSales from './pages/TrailerSales.jsx';
import StaleInventory from './pages/StaleInventory.jsx';
import FresnoInventory from './pages/FresnoInventory.jsx';
import EodParts from './pages/EodParts.jsx';
import Reports from './pages/Reports.jsx';
import RepActivity from './pages/RepActivity.jsx';
import UserActivity from './pages/admin/UserActivity.jsx';
import ContactLists from './pages/admin/ContactLists.jsx';
import AutomationSettings from './pages/admin/AutomationSettings.jsx';
import IngestedEmails from './pages/admin/IngestedEmails.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/sms-terms" element={<SmsTerms />} />
      <Route path="/change-password" element={<RequireAuth><ChangePassword /></RequireAuth>} />
      <Route element={<RequireAuth><AppShell /></RequireAuth>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/due-for-visit" element={<TripPlanner />} />
        <Route path="/customers/schedule" element={<VisitSchedule />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/notes/new" element={<NoteCapture />} />
        <Route path="/notes/:id" element={<NoteDetail />} />
        <Route path="/followups" element={<Followups />} />
        <Route path="/followups/:id" element={<FollowupDetail />} />
        <Route path="/blitz" element={<Blitz />} />
        <Route path="/pipeline" element={<Pipeline />} />
        <Route path="/pipeline/:id" element={<DealDetail />} />
        <Route path="/change-requests" element={
          <RequireAuth roles={['superadmin']}><ChangeRequests /></RequireAuth>
        } />
        <Route path="/ai-questions" element={<AIQuestions />} />
        <Route path="/ai-questions/:id" element={<AIQuestions />} />
        <Route path="/recap" element={<WeeklyRecap />} />
        <Route path="/aging" element={<AgingServiceOrders />} />
        <Route path="/parts" element={<Parts />} />
        <Route path="/service" element={<Service />} />
        <Route path="/trailer-sales" element={<TrailerSales />} />
        <Route path="/fresno-inventory" element={
          <RequireAuth branches={['FRESNO']}><FresnoInventory /></RequireAuth>
        } />
        <Route path="/parts/eod" element={<EodParts />} />
        <Route path="/reports" element={<Navigate to="/reports/sales" replace />} />
        <Route path="/reports/sales" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin','sales']}><Reports /></RequireAuth>
        } />
        <Route path="/reports/activity" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin','sales']}><RepActivity /></RequireAuth>
        } />
        <Route path="/stale-inventory" element={<StaleInventory />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/help" element={<Help />} />
        <Route path="/admin/users" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin']} perm="can_access_user_admin"><AdminUsers /></RequireAuth>
        } />
        <Route path="/admin/audit-log" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin']}><AuditLog /></RequireAuth>
        } />
        <Route path="/admin/dashboard" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin']}><ManagerDashboard /></RequireAuth>
        } />
        <Route path="/admin/bdm-performance" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin']}><BdmPerformance /></RequireAuth>
        } />
        <Route path="/admin/stale-followups" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin']}><StaleFollowups /></RequireAuth>
        } />
        <Route path="/admin/executive" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin']}><Executive /></RequireAuth>
        } />
        <Route path="/admin/reps/:id" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin']}><RepDetail /></RequireAuth>
        } />
        <Route path="/admin/user-activity" element={
          <RequireAuth roles={['superadmin']}><UserActivity /></RequireAuth>
        } />
        <Route path="/admin/contact-lists" element={
          <RequireAuth roles={['superadmin']}><ContactLists /></RequireAuth>
        } />
        <Route path="/admin/automation-settings" element={
          <RequireAuth roles={['superadmin','dealer_admin']}><AutomationSettings /></RequireAuth>
        } />
        <Route path="/admin/ingested-emails" element={
          <RequireAuth roles={['superadmin','dealer_admin','branch_admin']}><IngestedEmails /></RequireAuth>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
